import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EWaitingRoomPatientStatus;
(function (EWaitingRoomPatientStatus) {
  EWaitingRoomPatientStatus["Arrived"] = "arrived";
  EWaitingRoomPatientStatus["Waiting"] = "waiting";
  EWaitingRoomPatientStatus["Admitted"] = "admitted";
  EWaitingRoomPatientStatus["Discharged"] = "discharged";
  EWaitingRoomPatientStatus["Expired"] = "expired";
  EWaitingRoomPatientStatus["Removed"] = "removed";
})(EWaitingRoomPatientStatus || (EWaitingRoomPatientStatus = {}));
export let EWaitingRoomPatientSource;
(function (EWaitingRoomPatientSource) {
  EWaitingRoomPatientSource["Followup"] = "followup";
  EWaitingRoomPatientSource["Ui"] = "ui";
})(EWaitingRoomPatientSource || (EWaitingRoomPatientSource = {}));
export const fieldsWaitingRoomPatient = _extends({}, fieldsIBaseModel, {
  appointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  expiredAt: {
    type: 'Date'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  notes: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  patientAdmittedAt: {
    type: 'Date'
  },
  patientArrivedAt: {
    type: 'Date'
  },
  patientWaitingSince: {
    type: 'Date'
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  providerDischargedAt: {
    type: 'Date'
  },
  source: {
    type: 'Option',
    values: EWaitingRoomPatientSource
  },
  status: {
    type: 'Option',
    values: EWaitingRoomPatientStatus
  },
  waitingRoom: {
    type: 'ID',
    ref: EModel.WaitingRoom
  }
});